import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const nomad: Collection = {
  id: 'sp-nomad',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Nomad',
  subTitle: 'Tijdloos',
  banner: 'nomad/nomad-banner.jpg',
  items: [
    {
      id: 'sp-nomad-1',
      collectionImages: [
        {
          image: 'nomad/Nomad_7.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'nomad/Nomad.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-nomad-2',
      collectionImages: [
        {
          image: 'nomad/Nomad_6.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'nomad/Nomad_15.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    'd4a2031d-72a1-4fc8-87e7-5359cca8e2d6',
    '1fe16277-60fb-4242-8de2-6eb7899fd21e',
    '19cdf0fe-cccd-45ff-9ea4-70e841201a6e',
    'fbd2ce7a-7821-4c9f-93d3-52228f5db343',
    '02abe038-da3f-4b24-adbf-540933a3d782',
    'af2ba24b-0c47-4410-88fb-a3c41f6b0a31',
    '7ee9c14e-3422-4517-8063-12b6f3783cfc',
    'bc864d04-50a3-4da6-95fc-00c4e320fc0f',
    '4df1eecc-adb0-4b50-9b4f-a154cd986ba9',
    '6cbba37f-379d-4206-9179-30f6185020ba',
    'f7f2e85c-00a0-4a51-afc3-a0c5dcd4469f',
    '6b230949-15ca-4235-9050-3242e036dc28',
    '5abd54fe-1395-4a0d-a5d7-b776f2385f1d',
    'eb803e81-9282-4a59-a0c1-bfd06d52e923',
    '7af1cb0f-47d1-4c98-9383-1550f11ffe52',
    'ac831021-4fbe-45e9-9617-784f0f04089b',
    'af06ab67-e278-477d-a659-95d5244dc95a',
    '6ec4a2c4-c41c-4892-aa44-f7604980b7c4',
    '4f072903-5775-49f8-a1d7-2f17c12eb1c7',
    '6c4c87b7-2d06-418f-be11-447f788fa99c'
  ]
};
